import constate from 'constate';
import { useState } from 'react';

import { useScrollToFocus } from './useScrollToFocus';
import { PartDetailsTab } from '../enums';

const usePartDetailsFocus = () => {
  const [isHeaderCollapsed, setIsHeaderCollapsed] = useState(false);
  const [activeTab, setActiveTab] = useState<PartDetailsTab | null>(null);

  return { isHeaderCollapsed, setIsHeaderCollapsed, activeTab, setActiveTab };
};

export const [PartDetailsFocusProvider, usePartDetailsFocusContext] = constate(usePartDetailsFocus);

interface IOptions {
  getRowCount?: () => number;
  minRowsForTrigger?: number;
}

// Per-tab convenience wrapper. The active tab gets the setter; inactive tabs
// receive `undefined` so their hook stays inert.
export const usePartDetailsScrollToFocus = (tab: PartDetailsTab, options: IOptions = {}) => {
  const { isHeaderCollapsed, setIsHeaderCollapsed, activeTab } = usePartDetailsFocusContext();
  const isActive = activeTab === tab;
  // Destructure so callers can't override isFocused/onFocusChange via options.
  const { getRowCount, minRowsForTrigger } = options;

  return useScrollToFocus({
    isFocused: isHeaderCollapsed && isActive,
    onFocusChange: isActive ? setIsHeaderCollapsed : undefined,
    getRowCount,
    minRowsForTrigger,
  });
};
